// React
import React from 'react';
import Utils from '../../utils/utils';
import { Link } from 'react-router-dom';
import appRouter from '../../utils/appRouter';
import FooterMenu from './footerMenu.component.jsx';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';

import { Image, Panel, Row, Col } from 'react-bootstrap';

import UserApi from '../../api/user-api';

class Footer extends React.Component {
	constructor(props) {
		super(props);
	}

	isPath(path) {
		let regex = new RegExp('/' + path);
		return regex.test(this.props.location.pathname);
	}

	render() {
		return (
			<div>

				{/* UNKNOWN USER */}
				{!UserApi.hasPlanActive(this.props.user) && !this.props.isError &&
					<div className="bg-grey shadow">
						<div className="container-flex panel-offer">
							<Col md={12}>
								<h1 className="text-bold text-center">
									<FormattedMessage id="footer.title" />
								</h1>
								<h2 className="text-regular text-center">
									<FormattedMessage id="footer.subTitle" />
								</h2>

								<div className="row-mobile">
									<div className="bg-purple">
										<h1 className="text-white text-light">
											<FormattedMessage id="footer.panelPurple.text" values={{
												playNowButton: (
													<Link className="text-white" to={appRouter.getLink('game')}>
														<FormattedHTMLMessage id="footer.panelPurple.playNowBtnText" />
													</Link>
												),
												htmlText: <FormattedHTMLMessage id="footer.panelPurple.htmlText" />
											}} />
										</h1>
									</div>
								</div>
							</Col>
						</div>
					</div>
				}

				{/* LOGGED USER */}
				{UserApi.hasPlanActive(this.props.user) && (this.isPath('home') || this.isPath('ticket')) &&
					<div className="bg-grey shadow">
						<div className="container-flex panel-offer logged text-center">
							<Col md={12}>
								<h2 className="text-bold">
									<FormattedHTMLMessage id="footer.loggedUserText" />
								</h2>
								<Link to={appRouter.getLink('game')} onClick={() => { Utils.gaSend('Assinatura', 'Estímulo', 'Jogue Agora'); }} className="btn btn-default">
									<FormattedHTMLMessage id="btn.startPlayNow" />
								</Link>
							</Col>
						</div>
					</div>
				}

				<div className={"footer" + (this.props.isError ? " error" : "")}>
					<div className="container-flex">
						{/* MENU */}
						<FooterMenu />
						<hr />

						{/* TEXT */}
						<Row>
							<Col sm={10} smOffset={1}>
								<p className="text-center">
									<FormattedMessage id="footer.text" />
								</p>
							</Col>
						</Row>

						{/* IMAGES */}
						<ul className="nav nav-img">
							<li>
								<Image src={Utils.getImgPath() + "claro.png"} alt="" />
							</li>
							<li>
								<Image src={Utils.getImgPath() + "imusica.png"} alt="" />
							</li>
						</ul>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = function (store) {
	return {
		location: store.locationState.location,
		user: store.userState
	};
};

export default connect(mapStateToProps)(Footer);


// WEBPACK FOOTER //
// ./src/components/core/footer.component.jsx